import { signal } from "@preact/signals-react";
import IntegerField from "components/MeForm/IntegerField";
import { TrashIcon } from "components/Icons";

const ATTRS = { level: "wizard" };

export default function ProductItemCard({
  item,
  index,
  fieldQuantity,
  onRemove,
  readOnly,
}) {
  return (
    <div
      key={index}
      className="flex relative justify-between space-x-4 items-center bg-white border border-gray-200 rounded-md shadow-md py-1 px-4 my-2"
    >
      <div className="flex flex-col">
        <span className="font-bold">{item.name}</span>
        <span>
          <span className="font-bold">Código:</span> {item.code}
        </span>
      </div>

      <div className="max-w-[220px] flex space-x-8">
        <IntegerField
          field={{ ...fieldQuantity, name: index, readOnly }}
          attrs={ATTRS}
          data={signal(item.quantity)}
        />
        {!readOnly && (
          <TrashIcon
            className="size-10 cursor-pointer text-rose-500 fill-current my-auto active:scale-90"
            onClick={() => onRemove(item)}
          />
        )}
      </div>
    </div>
  );
}
